import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "../../constants";

export interface Credentials {
  email: string;
  password: string;
}

export interface LoggedInUser {
  id: number;
  email: string;
  name: string;
  token: string;
}

export interface Register {
  deviceId: string;
  name: string;
  email: string;
  password: string;
}

const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}/auth`
  }),
  endpoints(builder) {
    return {
      tryLogin: builder.mutation<LoggedInUser, Credentials>({
        query: data => {
          return {
            url: "/signin",
            body: {
              email: data.email,
              password: data.password
            },
            method: "POST"
          };
        }
      }),
      tryRegister: builder.mutation<LoggedInUser, Register>({
        query: data => {
          return {
            url: "/register",
            body: {
              ...data
            },
            method: "POST"
          };
        }
      })
    };
  }
});

export const { useTryLoginMutation, useTryRegisterMutation } = authApi;
export { authApi };
